import { Link } from "react-router-dom";
import { PageLayout } from "@/components/PageLayout";
import { CalculatorCard } from "@/components/CalculatorCard";
import { calculators } from "@/data/calculators";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Coffee, Search } from "lucide-react";
import { Button } from "@/components/ui/button";
import logoLight from "@/assets/logo-light_t.png";
import logoDark from "@/assets/logo-dark_t.png";
import { useTranslation } from "react-i18next";
import { useLanguageAwareSEO } from "@/hooks/useLanguageAwareSEO";
import { breadcrumbSchema } from "@/utils/structuredData";

export default function Lifestyle() {
  const { t } = useTranslation();
  const lifestyleCalculators = calculators.filter(calc => calc.category === "general" && calc.subcategory === "Lifestyle");

  useLanguageAwareSEO([
    (lang) => breadcrumbSchema([
      { name: "Home", url: "https://calclab.app" },
      { name: t('categories.pages.lifestyle.title'), url: "https://calclab.app/lifestyle" }
    ], lang)
  ]);

  return (
    <PageLayout>
      <div className="space-y-8">
        <div className="text-center space-y-4">
          <div className="flex justify-center">
            <Coffee className="h-16 w-16 text-primary" />
          </div>
          <h1 className="text-4xl font-bold tracking-tight">{t('categories.pages.lifestyle.title')}</h1>
          <p className="text-xl text-muted-foreground max-w-2xl mx-auto">
            {t('categories.pages.lifestyle.description')}
          </p>
        </div>

        <Card className="border-primary/20">
          <CardHeader>
            <CardTitle>{t('categories.pages.lifestyle.cardTitle')}</CardTitle>
            <CardDescription>
              {t('categories.pages.lifestyle.cardDescription')}
            </CardDescription>
          </CardHeader>
          <CardContent>
            <p className="text-muted-foreground">
              {t('categories.pages.lifestyle.cardContent')}
            </p>
          </CardContent>
        </Card>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {lifestyleCalculators.map(calculator => (
            <CalculatorCard key={calculator.id} {...calculator} />
          ))}
        </div>
      </div>
    </PageLayout>
  );
}
